import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";
import { analytics } from "./analytics";

import { API } from "./apiConfig";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // null = checking, false = not authenticated, object = authenticated
  const [user, setUser] = useState(null);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/auth/me`, { withCredentials: true });
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
    setUser(data);
    analytics.loginCompleted();
    return data;
  };

  const register = async (email, password, name, pendingCloverToken = null) => {
    const payload = { email, password, name };
    if (pendingCloverToken) {
      payload.pending_clover_token = pendingCloverToken;
    }
    const { data } = await axios.post(`${API}/auth/register`, payload, { withCredentials: true });
    setUser(data);
    analytics.signupCompleted(pendingCloverToken ? "clover" : "email");
    return data;
  };

  const logout = async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
    } catch {
      // Logout API may fail (e.g. network issue) — still clear local state
    }
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
